import {
  BaseTransientState,
  FeatureToggles,
  Regexps,
  Rolle,
  VorvertragVorschaedenState,
} from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { GlobalActions, RoleDeterminedPayload } from '@ps20-frontend/shop-integration-redux';
import { RsVermieterActions } from '../rs-vermietung-actions.service';

export interface TransientState extends BaseTransientState, VorvertragVorschaedenState, Rolle {
  tarifierungIsInProgress: boolean;
}

export const transientStateReducer = function (
  sectionState: TransientState = null,
  action: AnyAction,
): TransientState {
  const newState = {
    ...sectionState,
  };
  switch (action.type) {
    case RsVermieterActions.ZURUECK_ZUM_SHOP_MODAL_OPEN: {
      return { ...newState, zurueckZumShopModalOpen: true };
    }
    case RsVermieterActions.ZURUECK_ZUM_SHOP_MODAL_CLOSE: {
      return { ...newState, zurueckZumShopModalOpen: false };
    }
    case GlobalActions.TARIFIERUNG_HAS_STARTED: {
      return { ...newState, tarifierungIsInProgress: true };
    }
    case GlobalActions.TARIFIERUNG_HAS_ENDED: {
      return { ...newState, tarifierungIsInProgress: false };
    }
    case GlobalActions.SET_PRICE_GUARANTEE: {
      return { ...sectionState, priceGuarantee: action.payload };
    }
    case GlobalActions.CHANGE_RELEVANT_RISKDATA_HASH: {
      return {
        ...sectionState,
        priceGuarantee: false,
      };
    }
    case GlobalActions.FEATURE_TOGGLE_RECEIVED: {
      const actionPayload: FeatureToggles = action.payload;
      return { ...sectionState, featureToggles: actionPayload };
    }
    case GlobalActions.REGEXPS_RECEIVED: {
      const actionPayload: Regexps = action.payload;
      return { ...sectionState, regexps: actionPayload };
    }
    case GlobalActions.SETTINGS_RECEIVED:
      return {
        ...sectionState,
        settings: action.payload,
      };
    case GlobalActions.ROLE_DETERMINED: {
      const actionPayload: RoleDeterminedPayload = action.payload;
      return { ...sectionState, role: actionPayload.role };
    }
    case GlobalActions.KOOPERATIONEN_LIST_RECEIVED: {
      return {
        ...sectionState,
        kooperationen: action.payload,
      };
    }
    default:
      return newState;
  }
};
